import React from 'react';
import ThreejsDrawingSystem from 'drawing/threejs/ThreejsDrawingSystem';
import AnimationController from './AnimationController';
import './Threejs.css';

type Props = {
    drawingSystem: ThreejsDrawingSystem;
};

const ThreeJSComponent = ({ drawingSystem }: Props) => {
    const containerRef = React.useRef<HTMLDivElement>(null);

    React.useEffect(() => {
        containerRef.current?.appendChild(drawingSystem.getCanvas());
        drawingSystem.render();
        // === THREE.JS EXAMPLE CODE END ===
    }, [drawingSystem]);

    return (
        <div>
            <div ref={containerRef} />
            <input
                type="button"
                value="Reset Camera"
                onClick={(): void => {
                    drawingSystem.setCamera();
                    drawingSystem.render();
                }}
            />
            <div className="animationController">
                Playback: <AnimationController drawingSystem={drawingSystem} />
            </div>
        </div>
    );
};

export default ThreeJSComponent;
